import {
  InstancesDataProvider as instances,
  TenantsDataProvider as tenants,
  EksDataProvider as eks,
  PoolsDataProvider as pools,
  NodegroupsDataProvider as nodegroups,
  AuditDataProvider as audits,
  AddonsDataProvider as addons,
  AddonDataProvider as addon,
  MonitoringDataProvider as monitorings,
  UsersDataProvider as users,
  EventDataProvider as events,
  VersionSettingsDataProvider as versionSettings,
  ProfilesDataProvider as profiles,
  SubscriptionsDataProvider as subscriptions,
  MaintenanceDataProvider as maintenances
} from '@/resources-def';

const ResourcesProviderMap = { eks, instances, pools, nodegroups, tenants, audits, addons, addon, monitorings, users, events, versionSettings, profiles, subscriptions, maintenances };

export const dataProvider = {
  getList: async ({ resource, pagination, filters, sorters, meta }) => {
    if (ResourcesProviderMap[resource] && ResourcesProviderMap[resource].getList) {
      return ResourcesProviderMap[resource].getList({ pagination, filters, sorters, meta });
    }
    throw new Error("Function not implemented.");
  },
  getOne: async ({ resource, id, meta }) => {
    if (ResourcesProviderMap[resource] && ResourcesProviderMap[resource].getOne) {
      return ResourcesProviderMap[resource].getOne({ id, meta });
    }
    throw new Error("Function not implemented.");
  },
  create: async ({resource, variables, meta}) => {    
    if (ResourcesProviderMap[resource] && ResourcesProviderMap[resource].create) {
      return ResourcesProviderMap[resource].create({ variables, meta });
    }
    throw new Error("Function not implemented.");
  },
  // { resource, id, variables: { action, data } }
  update: async ({ resource, ...params }) => {
    if (ResourcesProviderMap[resource] && ResourcesProviderMap[resource].update) {
      return ResourcesProviderMap[resource].update(params);
    }
    throw new Error("Function not implemented.");
  },
  deleteOne: async (...params) => {
    const { resource } = params[0];
    if (ResourcesProviderMap[resource] && ResourcesProviderMap[resource].deleteOne) {
      return ResourcesProviderMap[resource].deleteOne(...params);
    }
    throw new Error("Function not implemented.");
  },
  getApiUrl: async () => {
    throw new Error("Function not implemented.");
  },
};
